module.exports = __webpack_public_path__ + "static/media/delivery_icon.111792c8.svg";